<template>
	<div class="success">
		<img class="image_success" src="@/assets/image/image_success.png" alt="">
		<div>
			<p style="font-weight: bold;color: green;font-size: 20px;line-height: 36px;">{{ $t('payment_successful_text') }}!</p>
			<p><span>{{currTimer}}s</span> <a class="color" v-on:click="toIndex()"> {{ $t('home_page_text') }}</a></p>
		</div>
	</div>
</template>
<script>
	export default {
		name: 'success',
		data() {
			return {
				timer: 3,
				currTimer: 3
			}
		},
		mounted() {
			this.$analytics.payment.result(true);
			this.setTimer();
		},
		beforeDestroy() {
			clearInterval(this.timer);
		},
		methods: {
			setTimer: function() {
				let _this = this;
				this.timer = setInterval(function() {
					_this.currTimer = _this.currTimer - 1;
					if (_this.currTimer === 0) {
						clearInterval(_this.timer);
						_this.toIndex();
					}
				}, 1000);
			},
			toIndex: function() {
				this.$router.push({
					path: '/'
				});
			}
		}
	}
</script>

<style></style>
